import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import requestPasswordResetToken from '../../actions/request-password-reset-token';
import ModalDialog from '../ModalDialog';
import TextField from '../fields/TextField';
import './_styles_/RequestPasswordResetPopup.css';
import useMultiValidator from '../../hooks/useMultiValidator';
import { userEmailValidator, userIdValidator } from '../../validators/users';
import InfoPanel from '../InfoPanel';
import { getPublicConfig } from "../../reducers";
import i18n from "../../i18n";
import PasswordField from '../fields/PasswordField';

RequestPasswordResetPopup.propTypes = {
    hideDialog: PropTypes.func.isRequired,
};

function RequestPasswordResetPopup(props) {
    const {
        hideDialog,
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { customer } = useSelector(getPublicConfig);
    const [userId, setUserId] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [totpToken, setTotpToken] = useState('');
    const onSubmit = (event) => {
        dispatch(requestPasswordResetToken(userId, userEmail, totpToken));
        event.preventDefault();
        hideDialog();
    };
    const onCancel = () => hideDialog();
    const { validators, isValid } = useMultiValidator(false, {
        userId: userIdValidator(t),
        userEmail: userEmailValidator(t),
    });
    const [isDisabled, setIsDisabled] = useState(true);
    isValid()
        .then(() => setIsDisabled(false))
        .catch(() => setIsDisabled(true));

    return (
        <ModalDialog onCancel={hideDialog}>
            <div className="request-password-reset-popup-dialog">
                <h4>{t('request-password-reset.title')}</h4>
                <form className="request-password-reset" onSubmit={onSubmit}>
                    <InfoPanel
                        message={i18n.t('request-password-reset.no-role-info', {customer: customer && customer + ' '})}
                    />
                    <div className="request-password-reset-input-row">
                        <TextField
                            label={t('request-password-reset.user-id')}
                            inputId="request-password-reset-user-id"
                            className="request-password-reset--field--user-id"
                            value={userId}
                            validator={validators.userId}
                            onChange={setUserId}
                            autoComplete="off"
                            placeholder="M7AUSRXX"
                            useDynamicWidth={false}
                        />
                    </div>
                    <div className="request-password-reset-input-row">
                        <TextField
                            label={t('request-password-reset.email')}
                            inputId="request-password-reset-email"
                            className="request-password-reset--field--email"
                            value={userEmail}
                            validator={validators.userEmail}
                            onChange={setUserEmail}
                            autoComplete="off"
                            placeholder="your.email@example.com"
                            useDynamicWidth={false}
                        />
                    </div>
                    <div className="request-password-reset-input-row">
                        <PasswordField
                            label={t('twoFA.token')}
                            icon="info"
                            iconTooltip={t('twoFA.token-tooltip')}
                            inputId="request-password-reset-token"
                            className="request-password-reset--field--token"
                            onChange={setTotpToken}
                            useDynamicWidth={false}
                        />
                    </div>
                    <div className="buttons">
                        <button disabled={isDisabled} className="button button-bordered request-password-reset-button" type="submit" aria-label={t('request-password-reset.submit')}><FontAwesomeIcon
                            icon="life-ring"
                        />&nbsp;{t('request-password-reset.submit')}
                        </button>
                        <button className="button button-bordered back-button" type="button" onClick={onCancel}>{t('button.cancel')}</button>
                    </div>
                </form>
            </div>
        </ModalDialog>
    );
}

export default RequestPasswordResetPopup;
